import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

$(function () {
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false
  });
  //閉じるリンクの設定
  $(document).on('click', '.popup-modal-dismiss', function (e) { 
    e.preventDefault();
    $.magnificPopup.close();
  });
});
  